import { render, staticRenderFns } from "./campos-obrigatorios-editor.vue?vue&type=template&id=5b0c93e6&scoped=true"
import script from "./campos-obrigatorios-editor.vue?vue&type=script&lang=js"
export * from "./campos-obrigatorios-editor.vue?vue&type=script&lang=js"
import style0 from "./campos-obrigatorios-editor.vue?vue&type=style&index=0&id=5b0c93e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c93e6",
  null
  
)

export default component.exports